import type {
  CoachingSessionStatus,
  ParticipationReport,
} from '@efdigital/ll-addon-data';

export const COACH_PENDING_CONFIRMATION_KEYS: CoachingSessionStatus[] = [
  'awaiting_coach_confirmation',
];

export const COACH_UPCOMING_KEYS: CoachingSessionStatus[] = ['scheduled'];

export const COACH_ACTION_REQUIRED_QUERY_KEYS: CoachingSessionStatus[] = [
  'external_change_flagged',
  'completed',
];

export const COACHEE_PENDING_CONFIRMATION_KEYS: CoachingSessionStatus[] = [
  'awaiting_coach_confirmation',
];

export const COACHEE_UPCOMING_KEYS: CoachingSessionStatus[] = ['scheduled'];

export const COACHEE_ACTION_REQUIRED_QUERY_KEYS: CoachingSessionStatus[] = [
  'external_change_flagged',
  'completed',
];

export type SessionActionFields = {
  status: CoachingSessionStatus;
  coachReport: ParticipationReport | null;
  coacheeReport: ParticipationReport | null;
};

export function coachSessionNeedsAction(session: SessionActionFields): boolean {
  if (session.status === 'external_change_flagged') {
    return true;
  }

  return session.status === 'completed' && !session.coachReport;
}

export function coacheeSessionNeedsAction(
  session: SessionActionFields
): boolean {
  if (session.status === 'external_change_flagged') {
    return true;
  }

  return session.status === 'completed' && !session.coacheeReport;
}

export function filterCoachActionRequired<T extends SessionActionFields>(
  sessions: T[]
): T[] {
  return sessions.filter(coachSessionNeedsAction);
}

export function filterCoacheeActionRequired<T extends SessionActionFields>(
  sessions: T[]
): T[] {
  return sessions.filter(coacheeSessionNeedsAction);
}

export function excludeFromLearnerHistory(
  session: SessionActionFields,
  role: 'coach' | 'coachee'
): boolean {
  if (role === 'coach') {
    return !coachSessionNeedsAction(session);
  }

  return !coacheeSessionNeedsAction(session);
}
